// Initial Certification runs as two scopes sharing one base key: `{base}:s1` and
// `{base}:s2`. Which one is live is decided by the BACKEND stage gate
// (GET /audit/projects/{id}/stage-gate -> activeStage), never by counting open
// tasks: Application Review and Scheduling are deliberately shared by both
// stages (see selectTasksForAuditScope), so Stage 1 looks "open" long after its
// FTRD-01 decision advanced the gate to Stage 2.

export const resolveBaseScopeKey = (scopeKey) =>
  String(scopeKey || '').replace(/:s[12]$/, '');

export const resolveGateStageSuffix = (activeStage) => {
  const stage = String(activeStage || '').toLowerCase();
  if (stage === 'stage1') return ':s1';
  // A completed cycle stays on Stage 2 -- that is where the certificate lives.
  if (stage === 'stage2' || stage === 'completed') return ':s2';
  return null;
};

// The scope key of the stage the gate says is active, or null when there is no
// gate for this base yet (async fetch, or a swallowed error) or the gate-aligned
// scope does not exist (single-stage cycle: Surveillance, Recertification).
// Callers fall back to their existing resolution on null.
export const resolveGateAlignedScopeKey = (scopeKey, stageGateMap = {}, availableScopeKeys = []) => {
  const base = resolveBaseScopeKey(scopeKey);
  if (!base) return null;
  const suffix = resolveGateStageSuffix(stageGateMap?.[base]?.activeStage);
  if (!suffix) return null;
  const candidate = `${base}${suffix}`;
  return availableScopeKeys.some((key) => String(key) === candidate) ? candidate : null;
};
